<template>
  <v-layout wrap justify-center class="pa-6">
    <v-flex xs12 md12>
      <v-card
        class="mx-auto col-12"
        max-width="1300"
        elevation="2"
        :loading="card.loader"
        :disabled="card.disabled"
      >
        <v-card-title>
          <v-list-item>
            <v-list-item-icon>
              <v-icon size="30" color="blue darken-4 "
                >mdi-invoice-text-arrow-right-outline</v-icon
              >
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="headline"
                >Reporte Cartera por Concepto</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
        </v-card-title>
        <div class="pa-0 px-8">
          <v-card-text class="px-0 pa-0">
            <v-row>
              <v-col class="d-flex" cols="3">
                <v-select
                  :items="ruts"
                  label="Rut a Procesar"
                  outlined
                  clearable
                  hide-details
                  v-model="form.ruts"
                  return-object
                  required
                ></v-select>
              </v-col>

              <v-col class="d-flex" cols="6">
                <v-autocomplete
                  label="Seleccione el Rut"
                  v-model="form.selruts"
                  :items="tablaruts"
                  :item-text="format_ruts"
                  item-value="cod_puc"
                  hide-details
                  return-object
                  outlined
                  v-if="form.ruts && form.ruts.value != 1"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="d-flex" sm="3">
                <v-menu
                  v-model="pickeFechaIni"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="form.fechaInicial"
                      label="Fecha Corte"
                      append-icon="event"
                      hide-details
                      outlined
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="form.fechaInicial"
                    @input="pickeFechaIni = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>

            <v-row class="d-flex justify-left">
              <v-col cols="12">
                <v-btn
                  color="indigo"
                  class="mr-2 white--text px-12"
                  large
                  depressed
                  @click="cargarcontenido"
                  :loading="btnEnvio.loader"
                  :disabled="btnEnvio.disabled"
                >
                  Consultar
                  <v-icon right dark>mdi-file-upload-outline</v-icon>
                </v-btn>
                <v-btn
                  color="green"
                  class="mr-2 white--text px-12"
                  large
                  depressed
                  :disabled="contenido.length > 0 ? false : true"
                  @click="descargar_excel()"
                >
                  <v-icon right class="mr-2">mdi-file-excel-box</v-icon>
                  Descargar EXCEL
                </v-btn>
                <!-- <v-btn
                  @click="descargar_pdf()"
                  color="red darken-2"
                  class="white--text px-12"
                  large
                  depressed
                  :disabled="contenido.length > 0 ? false : true"
                >
                  <v-icon right dark>mdi-pdf-box</v-icon> Descargar .PDF
                </v-btn> -->
              </v-col>
            </v-row>

            <v-row class="d-flex mb-4 justify-center align-center">
              <v-col cols="6" lg="6" md="12" sm="12">
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Buscar"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>

            <v-data-table
              :headers="headers"
              :items="contenido"
              item-key="index"
              :search="search"
            >
              <template v-slot:item.id_rep="{ item }">
                {{ parseInt(item.id_rep) }}
              </template>

              <!-- <template v-slot:item.codcta_rep="{ item }">
                <label v-if="item.docinter_rep"
                  >{{ item.codcta_rep }} - {{ item.descripcta_rep }}</label
                >
              </template> -->
              <!-- <template v-slot:item.dias_rep="{ item }">
                <label v-html="item.dias_rep"></label>
              </template>
              <template v-slot:item.vence_rep="{ item }">
                <b v-if="item.separador">{{ item.vence_rep }}</b>
                <label v-else>{{ item.vence_rep }}</label>
              </template>
              <template v-slot:item.xvencer_rep="{ item }">
                <b v-if="item.separador">{{ item.xvencer_rep }}</b>
                <label v-else>{{ item.xvencer_rep }}</label>
              </template>
              <template v-slot:item.vencido_rep="{ item }">
                <b v-if="item.separador">{{ item.vencido_rep }}</b>
                <label v-else>{{ item.vencido_rep }}</label>
              </template> -->
              <template v-slot:item.valor_rep="{ item }">
                <b v-if="item.separador">{{ item.valor_rep }}</b>
                <label v-else>{{ item.valor_rep }}</label>
              </template>

              <!-- <template v-slot:item.docinter_rep="{ item }">
                <v-btn
                  depressed
                  small
                  rounded
                  color="primary"
                  outlined
                  v-if="item.descripcta_rep"
                  @click="reimprimir(item)"
                  >{{ item.docinter_rep }}</v-btn
                >
              </template> -->
              <!-- <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                  <table class="col-8 mx-auto">
                    <tbody>
                      <tr>
                        <td>
                          <b>Imprimir Factura</b>
                        </td>
                        <td>{{ item.codcta_rep }}</td>
                      </tr>
                      <tr>
                        <td>
                          <b>Pagos</b>
                        </td>
                        <td>{{ item.pagos_rep }}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </template> -->
              <template v-slot:item.edit="{ item }">
                <v-icon small class="mr-2" @click="editar_item(item)"
                  >edit</v-icon
                >
              </template>
              <template v-slot:body.append>
                <td colspan="3" class="text-right">
                  <strong>TOTALES</strong>
                </td>
                <td class="text-xs-right text-center">
                  {{ formatNumero(totales.saldoCartera) }}
                </td>
                <td class="text-xs-right text-center">
                  {{ formatNumero(totales.saldoContabilidad) }}
                </td>
              </template>
            </v-data-table>
          </v-card-text>
        </div>
      </v-card>
    </v-flex>
    <v-overlay :value="loader">
      <flower-spinner :animation-duration="2500" :size="100" color="#0d47a1" />
    </v-overlay>
  </v-layout>
</template>

<script>
import post from "../../methods.js";
import { FlowerSpinner } from "epic-spinners";

var pdfMake = require("pdfmake/build/pdfmake.js");
var pdfFonts = require("pdfmake/build/vfs_fonts.js");
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
  components: {
    FlowerSpinner,
  },
  data() {
    return {
      errores: {
        punto_fact: false,
      },
      agencias: [],
      pickeFechaIni: false,
      cuentasContables: [],
      loader: false,
      singleExpand: true,
      expanded: [],
      contenido: [],
      tablaruts: [],
      tablasesor: [],
      empresa: [],
      search: "",
      form: {
        cuentaContable: null,
        fechaInicial: this.$moment().format("YYYY-MM-DD"),
        ruts: null,
        asesor: null,
      },
      headers: [
        {
          text: "Id",
          align: "center",
          value: "id_rep",
        },
        {
          text: "Propietario",
          align: "left",
          value: "descripcion_rep",
        },
        {
          text: "Concepto",
          align: "left",
          value: "descrcargo_rep",
        },
        {
          text: "Saldo Cartera",
          align: "center",
          value: "valor_rep",
        },
        {
          text: "Saldo Contabilidad",
          align: "center",
          value: "sdocontab_rep",
        },
      ],
      ruts: [
        { text: "Todos los Ruts", value: 1 },
        { text: "Seleccion Unica", value: 2 },
      ],
      asesor: [
        { text: "Todos los Asesores", value: 1 },
        { text: "Seleccion Unica", value: 2 },
      ],

      card_estado: false,
      btnEnvio: {
        loader: false,
        disabled: false,
      },
      card: {
        loader: false,
        disabled: false,
      },
      logoSrc:
        "https://server1ts.net/datos/image/clientes/" +
        parseFloat(sessionStorage.Sesion.substr(0, 15)) +
        ".png",
      totales: {
        saldoCartera: 0,
        saldoContabilidad: 0,
      },
      disabledSelect: false,
    };
  },
  async created() {
    await this.cargar_empresa();
    this.cargarTablaruts();
    this.cargarTablasesor();
    this.cargarTablaAg();
  },
  methods: {
    cargar_empresa() {
      return new Promise((resolve) => {
        post
          .postData({
            url: "Financiero/dlls/CfEmpresaJ.dll",
            data: sessionStorage.Sesion + "|",
            method: "",
          })
          .then((data) => {
            this.empresa = data[0];
            resolve(true);
          })
          .catch((err) => {
            console.log(err);
            this.$emit("snack", {
              color: "error",
              text: "Error al cargar empresa",
              estado: true,
            });
          });
      });
    },

    // descargar_pdf() {
    //   let data = this.contenido;
    //   let data_format = [];
    //   let fecha_corte = this.form.fechaInicial.replace(/\-/g, "/");
    //   let granTotalxVencer = this.totales.xvencer;
    //   let granTotalVencido = this.totales.vencido;
    //   let granTotal = this.totales.total;

    //   data_format.push([
    //     { text: "Agencia", style: "header_table" },
    //     { text: "Descripción", style: "header_table" },
    //     { text: "Factura", style: "header_table" },
    //     { text: "Fecha", style: "header_table" },
    //     { text: "Vencimiento", style: "header_table" },
    //     { text: "Días", style: "header_table" },
    //     { text: "Por vencer", style: "header_table" },
    //     { text: "Vencido", style: "header_table" },
    //     { text: "Total", style: "header_table" },
    //   ]);

    //   data.forEach((el) => {
    //     let item;

    //     if (el.vence_rep.trim() != "Sub-total:") {
    //       item = [
    //         el.id_rep.trim(),
    //         el.descripcion_rep.trim(),
    //         el.pref_rep.trim() + " " + el.factura_rep.trim(),
    //         el.fecha_rep.trim(),
    //         el.vence_rep.trim(),
    //         el.dias_rep.replace(/ /g, ""),
    //         el.xvencer_rep.replace(/ /g, ""),
    //         el.vencido_rep.replace(/ /g, ""),
    //         { text: el.total_rep.trim(), alignment: "center" },
    //       ];
    //     } else {
    //       item = [
    //         "",
    //         "",
    //         "",
    //         "",
    //         {
    //           text: "Sub-total: ",
    //           bold: true,
    //           margin: [0, 0, 0, 20],
    //           fontSize: 9,
    //         },
    //         "",
    //         { text: el.xvencer_rep.replace(/ /g, ""), bold: true },
    //         { text: el.vencido_rep.replace(/ /g, ""), bold: true },
    //         { text: el.total_rep.trim(), bold: true, alignment: "center" },
    //       ];
    //     }

    //     data_format.push(item);
    //   });

    //   data_format.push([
    //     "",
    //     "",
    //     "",
    //     "",
    //     {
    //       text: "Totales: ",
    //       bold: true,
    //       fontSize: 10,
    //     },
    //     "",
    //     { text: this.formatNumero(granTotalxVencer), bold: true },
    //     { text: this.formatNumero(granTotalVencido), bold: true },
    //     { text: this.formatNumero(granTotal), bold: true, alignment: "center" },
    //   ]);

    //   let logo_src = require(`../../assets/image/clientes/${parseFloat(
    //     sessionStorage.Sesion.substr(0, 15)
    //   )}.png`);
    //   this.pdfs.getBase64(logo_src).then((logo) => {
    //     this.pdfs._informe({
    //       data: data_format,
    //       header_pdf: [
    //         {
    //           text: [{ text: "Fecha corte: ", bold: true }, fecha_corte],
    //         },
    //       ],
    //       titulo: "Reporte Cartera",
    //       logo,
    //       fontSize: 8,
    //     });
    //   });
    // },

    descargar_excel() {
      let data = [...this.contenido];

      // Agrupa datos por 'id_rep'
      let groupedData = {};
      data.forEach((item) => {
        // Elimina los ceros a la izquierda de 'id_rep' y manténlo como string
        let id_rep_sin_ceros = item.id_rep.replace(/^0+/, "");

        if (!groupedData[id_rep_sin_ceros]) {
          groupedData[id_rep_sin_ceros] = {
            id_rep: id_rep_sin_ceros,
            propietario_rep: item.descripcion_rep.trim(),
            observaciones_rep: window.atob(
              item.base1_pr.trim() +
                item.base2_pr.trim() +
                item.base3_pr.trim() +
                item.base4_pr.trim() +
                item.base5_pr.trim() +
                item.base6_pr.trim()
            ),
          };
        }
        groupedData[id_rep_sin_ceros][item.descrcargo_rep.trim()] = parseFloat(
          item.valor_rep.replace(/,/g, "")
        );

        // Procesa el valor de 'sdocontab_rep'
        let sdocontab_value = parseFloat(
          item.sdocontab_rep.replace(/,/g, "").replace(/\s+/g, "")
        );

        // Si el valor es negativo, lo reemplaza con 0
        if (sdocontab_value < 0) {
          sdocontab_value = 0;
        }

        // Suma el valor de 'sdocontab_rep' al total por id_rep
        groupedData[id_rep_sin_ceros].total_sdocontab =
          (groupedData[id_rep_sin_ceros].total_sdocontab || 0) +
          sdocontab_value;
      });

      // Crea columnas dinámicas basadas en 'descrcargo_rep'
      let columnas = [
        {
          title: "Inmueble",
          value: "id_rep",
          format: "string",
        },
        {
          title: "Propietario",
          value: "propietario_rep",
          format: "string",
        },
      ];

      let uniqueDescrcargo = [
        ...new Set(data.map((item) => item.descrcargo_rep.trim())),
      ];

      uniqueDescrcargo.forEach((descr) => {
        columnas.push({
          title: descr,
          value: descr,
          format: "money",
          totalsRowFunction: "sum",
        });
      });

      // Agrega la columna de "TOTAL"
      columnas.push({
        title: "TOTAL",
        value: "total",
        format: "money",
        totalsRowFunction: "sum",
      });

      // Agrega la columna de "TOTAL Sdo. Contab"
      columnas.push({
        title: "TOTAL Sdo. Contab",
        value: "total_sdocontab",
        format: "money",
        totalsRowFunction: "sum",
      });

      columnas.push({
        title: "Observaciones",
        value: "observaciones_rep",
        format: "string",
      });

      // Crea el arreglo final de datos para la tabla
      let data_parse = Object.values(groupedData).map((item) => {
        let total = uniqueDescrcargo.reduce((sum, descr) => {
          return sum + (item[descr] || 0);
        }, 0);

        return { ...item, total };
      });

      // Ordena por 'id_rep' de menor a mayor
      data_parse.sort((a, b) => {
        return parseFloat(a.id_rep) - parseFloat(b.id_rep);
      });

      let header_format = [
        {
          text: this.empresa.descrip_empr,
          bold: true,
          size: 16,
        },
        {
          text: this.empresa.ideditado_empr,
          bold: true,
          size: 14,
        },
        {
          text: `CARTERA POR CONCEPTOS`,
          size: 14,
        },
        {
          text: `${this.form.fechaInicial}`,
          size: 12,
        },
      ];

      let logo_src = require(`../../assets/image/clientes/${parseFloat(
        sessionStorage.Sesion.substr(0, 15)
      )}.png`);
      this.pdfs.getBase64(logo_src).then((logo) => {
        this.excel
          ._informe({
            sheetName: "Cartera por Conceptos",
            header: header_format,
            logo,
            tabla: {
              columnas,
              totalsRow: true,
              data: data_parse,
              theme: "TableStyleMedium2",
            },
            archivo: `CARTERA_CONCEPTOS-${new Date().getTime()}`,
          })
          .then((data) => {
            console.log("Impresión de Excel terminada");
          });
      });
    },

    cargarTablaAg: function () {
      post
        .postData({
          url: "Financiero/dlls/Cfagenciasj.dll",
          data: sessionStorage.Sesion + "|",
          method: "",
        })
        .then((data) => {
          var filtro = data.filter((el) => el.estado_agc == "0");
          this.agencias = filtro;

          let ubica_perfil = this.empresa.ubicaperfil_empr;
          let ubica_rut = 1;
          let ubica_asesor = 1;

          if (this.empresa.contarem_empr == 1) {
            let busqueda_ubica = this.agencias.find(
              (el) => el.codigo_agc == ubica_perfil
            );
            this.form.punto_fact = busqueda_ubica;

            let busqueda_rut = this.ruts.find((el) => el.value == ubica_rut);
            this.form.ruts = busqueda_rut;

            let busqueda_ases = this.asesor.find(
              (el) => el.value == ubica_asesor
            );
            this.form.asesor = busqueda_ases;
            this.disabledSelect = true;
          }
        })
        .catch((err) => {
          console.log(err);
          this.$emit("snack", {
            color: "error",
            text: "Error al cargar Agencias",
            estado: true,
          });
        });
    },
    cargarcontenido() {
      var data = this.form;

      if (!data.ruts) {
        this.send_error("Selecciona el tipo de Ruts");
      } else if (data.ruts.value != 1 && !data.selruts) {
        this.send_error("Selecciona el código del Rut");
      } else {
        this.contenido = [];
        this.btnEnvio.loader = true;
        this.btnEnvio.disabled = true;
        var sesion = sessionStorage.Sesion;
        var selrut = data.selruts ? data.selruts.identificacion_rut : null;
        var asesor = 0;
        var punto = "0001";
        var tiporut = data.ruts.value;
        var tipoases = 1;
        let resumen = this.form.resumen ? "1" : "0";
        var fechaFinal = data.fechaInicial.replace(/\-/g, "");
        let calldll = "Phorizontal/dlls/RpCartera2J.DLL";

        var datosEnvio =
          sesion +
          "|" +
          punto +
          "|" +
          (tiporut == 1 ? "0" : selrut) +
          "|" +
          fechaFinal +
          "|" +
          (tipoases == 1 ? "0" : asesor) +
          "|" +
          resumen +
          "|";
        post
          .postData({
            url: calldll,
            data: datosEnvio,
            method: "",
          })
          .then((data) => {
            this.btnEnvio.loader = false;
            this.btnEnvio.disabled = false;
            this.loader = false;

            data.pop();

            this.contenido = data;
            let totales = { saldoCar: 0, saldoCont: 0 };

            data.forEach((el) => {
              totales.saldoCar +=
                parseFloat(el.valor_rep.replace(/,/g, "")) || 0;
              totales.saldoCont +=
                parseFloat(el.sdocontab_rep.replace(/,/g, "")) || 0;
            });

            this.totales = {
              saldoCartera: totales.saldoCar,
              saldoContabilidad: totales.saldoCont,
            };

            // var new_data = [];
            // var cuentaActual = null;
            // var cuentaSiguiente = null;
            // var subtotal_vencido = 0;
            // var subtotal_vencer = 0;
            // this.totales.xvencer = 0;
            // this.totales.vencido = 0;

            // data.forEach((item, index) => {
            //   cuentaActual = item.descripcion_rep;
            //   if (index + 1 != data.length)
            //     cuentaSiguiente = data[index + 1].descripcion_rep;

            //   item.index = index;
            //   item.descripcion_rep = item.descripcion_rep.replace(
            //     / +(?= )/g,
            //     ""
            //   );
            //   new_data.push(item);

            //   let vencido =
            //     parseFloat(item.vencido_rep.replace(/\,/g, "")) || 0;
            //   let xvencer =
            //     parseFloat(item.xvencer_rep.replace(/\,/g, "")) || 0;

            //   subtotal_vencido += vencido;
            //   subtotal_vencer += xvencer;

            //   this.totales.xvencer += xvencer;
            //   this.totales.vencido += vencido;

            //   let total = xvencer + vencido;
            //   item.valor_rep = this.formatNumero(total);

            //   if (cuentaActual != cuentaSiguiente || index + 1 == data.length) {
            //     let subtotal_total = subtotal_vencer + subtotal_vencido;

            //     new_data.push({
            //       separador: true,
            //       agencia_rep: "",
            //       descripcion_rep: "",
            //       direccion_rep: "",
            //       id_rep: "",
            //       pref_rep: "",
            //       factura_rep: "",
            //       fecha_rep: "",
            //       vence_rep: "Sub-total:",
            //       dias_rep: "",
            //       xvencer_rep: this.formatNumero(subtotal_vencer.toFixed(2)),
            //       vencido_rep: this.formatNumero(subtotal_vencido.toFixed(2)),
            //       total_rep: this.formatNumero(subtotal_total),
            //     });

            //     subtotal_vencido = 0;
            //     subtotal_vencer = 0;
            //   }
            // });

            // this.totales.total = this.totales.xvencer + this.totales.vencido;
          })
          .catch((err) => {
            console.log(err);
            this.btnEnvio.loader = false;
            this.btnEnvio.disabled = false;
            this.send_error("Error al cargar el reporte Cartera");
          });
      }
    },
    format_ruts: function (val) {
      return `${val.identificacion_rut} - ${val.descripcion_rut}`;
    },
    format_asesor: function (val) {
      return `${val.idases} - ${val.descripases}`;
    },
    cargarTablasesor: function () {
      post
        .postData({
          url: "Financiero/dlls/CfAsesorJ.dll",
          data: sessionStorage.Sesion + "|",
          method: "",
        })
        .then((data) => {
          this.tablasesor = [];
          this.tablasesor = JSON.parse(JSON.stringify(data));
        })
        .catch((err) => {
          this.$emit("snack", {
            color: "error",
            text: "Error al cargar registro",
            estado: true,
          });
        });
    },
    cargarTablaruts: function () {
      post
        .postData({
          url: "Financiero/dlls/Cfrutsj.dll",
          data: sessionStorage.Sesion + "|",
          method: "",
        })
        .then((data) => {
          this.tablaruts = data;
        })
        .catch((err) => {
          console.error(err);
          this.send_error("Error al cargar Ruts");
        });
    },
    format_punto_fact: function (val) {
      return `${val.codigo_agc} - ${val.descripcion_agc}`;
    },
    send_error(msj) {
      console.error("Error", msj);
      this.$emit("snack", {
        color: "error",
        text: msj,
        estado: true,
      });
    },
  },
};
</script>
